import { Injectable, Injector } from '@angular/core';
import { PoStorageService } from '@po-ui/ng-storage';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseResourceApi } from '../interfaces/base-resource-api.model';
import { BaseResourceOnlineService } from './base-resource/base-resource-online.service';

@Injectable({
  providedIn: 'root'
})
export class CustomFieldsService extends BaseResourceOnlineService {
  constructor(
    protected poStorageService: PoStorageService,
    protected override injector: Injector
  ) {
    super(injector, 'customFields');
    this.url = `${environment.url}api/pgv/customFields`;
  }

  getCustomFields(): Promise<BaseResourceApi> {
    return firstValueFrom(this.get());
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setCustomFieldsOnStorage(schema: string, fields: any[]): void {
    this.poStorageService.set(schema, JSON.stringify(fields));
  }

  getCustomFieldOnStorage(schema: string): Promise<string> {
    return this.poStorageService.get(schema);
  }
}
